import React from 'react';
import { Check } from 'lucide-react';
import Reveal from './Reveal';

/** Equipment-first onboarding, with a small HTML mock of the question. */
const weights = [8, 12, 16, 20, 24];
const owned = new Set([12, 16]);

const Equipment = () => (
  <section id="equipment" className="section" aria-labelledby="equipment-headline">
    <div className="section-inner split">
      <Reveal>
        <p className="eyebrow">Built for one or two bells</p>
        <h2 id="equipment-headline" className="h2">
          Start with what is on your floor.
        </h2>
        <p className="lead-sm">
          The first thing Bell Club asks is what you train with. One kettlebell is enough. Two opens
          more. Every session is then written for those bells - “heavy” means your heaviest, not a
          rack you do not own.
        </p>
        <ul className="ticks">
          {[
            'No gym, no barbell, no machine',
            'Loads resolved against the bells you actually have',
            'Buy a heavier bell later and the plan moves with you',
          ].map((t) => (
            <li key={t}>
              <span className="tick" aria-hidden="true">
                <Check size={14} strokeWidth={3.5} />
              </span>
              {t}
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal>
        <div
          className="panel mock-onboarding"
          role="img"
          aria-label="Onboarding asks: what do you train with? One kettlebell or two; then which weights - here 12 kg and 16 kg are selected."
        >
          <div aria-hidden="true">
            <div className="mock-q">What do you train with?</div>
            <div className="mock-options">
              <span className="mock-option">One kettlebell</span>
              <span className="mock-option on">Two kettlebells</span>
            </div>
            <div className="mock-q">Which weights?</div>
            <div className="mock-chips">
              {weights.map((w) => (
                <span key={w} className={`mock-chip ${owned.has(w) ? 'on' : ''}`}>
                  {w} kg
                </span>
              ))}
            </div>
            <div className="mock-continue">Continue</div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Equipment;
